import {Component, HostListener, Input} from "@angular/core";
import {StepNavigationElement} from "./step.navigation.element";

/**
 * Component which is used in the step navigation to show some extra navigation elements on the left and right side
 */
@Component({
    templateUrl: './step.navigation.extra.component.html',
    selector: '[app-step-navigation-extra]',
    standalone: false
})
export class StepNavigationExtraComponent {
  /**
   * The navigationElement to show
   */
  @Input() navigationElement: StepNavigationElement;

  /**
   * toggle for the overlay.
   */
  showOverlay: boolean = false;

  /**
   * if there is a click somewhere, close the overlay
   * @param event
   */
  @HostListener('window:click', ['$event'])
  closeOverlay(event): void {
    // only close the overlay if no part of the overlay was clicked
    const targets = [event.target];
    if(event.target.parentElement) {
      targets.push(event.target.parentElement);
    }
    if(targets.filter(element => element.classList.contains('show-overlay') || element.classList.contains('overlay')).length === 0) {
      this.showOverlay = false;
    }
  }
}
